import dayjs from 'dayjs'
import * as Actions from '../../../Modules/CmsActions'
import type { IPagination } from '../../../Types'

export type DocumentType = {
  active: number
  created_at: string
  cv: number
  description: null | string
  download_url: string
  file_name: string
  id: number
  title: string
}

export type DocumentNormalization = Record<number, DocumentType>

interface State {
  list: Array<{
    active: boolean
    created_at: string
    cv: number
    description: string | null
    download_url: string
    file_name: string
    id: number
    title: number
    updated_at: string
  }>
  pagination: IPagination
  loading: boolean
  statusMessage: string
  document: {
    id: number
    title: string
    updated_at: string
    created_at: string
    active: boolean
    cv: number
    file_name: string
    download_url: string
    file: string
  } | null
  error: boolean
  uploading: boolean
  success: boolean
  selectData: { label: string; value: string }[]
  conditions: {
    s: string
    start_date: Date | null
    end_date: Date | null
  }
}

const initialState: State = {
  list: [],
  pagination: {
    current_page: 1,
    first_page_url: null,
    from: 0,
    last_page: 1,
    last_page_url: null,
    next_page_url: null,
    path: null,
    per_page: 15,
    prev_page_url: null,
    to: 0,
    total: 0,
  },
  loading: false,
  statusMessage: '',
  document: null,
  error: false,
  uploading: false,
  success: false,
  selectData: [],
  conditions: {
    start_date: null,
    end_date: null,
    s: '',
  },
}

const UIDocumentReducer = (state: State = initialState, action) => {
  const { payload, error } = action

  switch (action.type) {
    case Actions.REQUEST_FETCH_DOCUMENTS:
    case Actions.REQUEST_FETCH_DOCUMENT_ID:
    case Actions.REQUEST_DELETE_DOCUMENT:
      return { ...state, loading: true }

    case Actions.FINISH_FETCH_DOCUMENTS:
      if (action.error === true) {
        return { ...state, loading: false }
      }

      // eslint-disable-next-line
      const yyyymmddFormat = (datetime) => {
        return dayjs(datetime).format('YYYY/MM/DD')
      }
      // eslint-disable-next-line
      const usage = action.payload.documents.map((doc) => {
        const editUpdatedAt = yyyymmddFormat(doc.updated_at)
        const editCreatedAt = yyyymmddFormat(doc.created_at)
        return {
          ...doc,
          active_label: doc.active ? '利用中' : '未使用',
          created_at: editCreatedAt,
          updated_at: editUpdatedAt,
        }
      })
      return {
        ...state,
        loading: false,
        list: usage,
        pagination: payload.pagination,
      }

    case Actions.FINISH_FETCH_DOCUMENT_ID:
      return error
        ? { ...state, loading: false }
        : {
            ...state,
            loading: false,
            document: payload.document,
          }

    case Actions.REQUEST_UPLOAD_DOCUMENT:
      return {
        ...state,
        loading: true,
        document: action.payload.file,
      }

    case Actions.RECEIVE_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        statusMessage: action.payload.text,
        error: action.payload.error,
      }

    case Actions.REQUEST_UPLOAD_FILE:
      return {
        ...state,
        uploading: true,
      }

    case Actions.FINISH_UPLOAD_FILE:
      return {
        ...state,
        success: true,
        uploading: false,
      }

    case Actions.RESET_UPLOAD_FILE_STATUS:
      return {
        ...state,
        success: false,
      }

    case Actions.FINISH_DELETE_DOCUMENT:
      return { ...state, loading: false }

    case Actions.REQUEST_FETCH_SEARCH_DOCUMENT:
      return { ...state, loading: true }

    case Actions.FINISH_FETCH_SEARCH_DOCUMENT:
      return {
        ...state,
        loading: false,
        list: payload.list,
        selectData: payload.selectData,
      }

    case Actions.REQUEST_CHANGE_CONDITION_DOCUMENT:
      return updateCondition(state, action.payload.value)

    case Actions.CLEAR_SEARCH_DOCUMENT:
      return { ...state, selectData: [] }

    default:
      return state
  }
}

const updateCondition = (state, value) => {
  return {
    ...state,
    conditions: value,
  }
}

export default UIDocumentReducer
